<script>
  import service from '../../../../domain/leiloes/services'
  export default{
    name: 'select-marca',
    props: {
      value: {
        required: true
      }
    },
    data () {
      return {
        id: null,
        loadError: false,
        isLoading: false,
        marcas: null
      }
    },
    computed: {
      model: {
        get () {
          return this.value === null ? '' : this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      load (id) {
        this.id = id
        this.isLoading = true
        service.buscaMarcas(id).then((response) => {
          this.isLoading = false
          this.marcas = response.data.marcas
        })
          .catch((response) => {
            this.isLoading = false
            window.responseError(response)
            console.log(response)
          })
      },
      change (v) {
        this.$emit('atualizaMarca', v.target.value)
      }
    },
    components: {}
  }
</script>

<template>
  <div class="form-group">
    <label class="col-lg-2 control-label">Marca</label>
    <div class="col-lg-10">
      <select :disabled="id === null" v-model="model" @change="change" class="form-control w-auto w-full-xs">
        <option disabled value="">{{ id !== null ? (isLoading ? 'Carregando' : 'Selecione') : 'Selecione o tipo de bem primeiro' }}</option>
        <option v-for="marca in marcas" :value="marca.id" :key="marca.id">{{ marca.nome }}</option>
      </select>
      <a v-if="loadError" class="btn text-danger" @click="load">Não foi possível carregar. Tente novamente</a>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// SelectMarca.vue?22e348a5